import { render, staticRenderFns } from "./CurriculumForm.vue?vue&type=template&id=a68c1386&scoped=true&"
import script from "@/views/Curricula/CurriculumForm.ts?vue&type=script&lang=ts&"
export * from "@/views/Curricula/CurriculumForm.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Curricula/curriculum-form.scss?vue&type=style&index=0&id=a68c1386&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68c1386",
  null
  
)

export default component.exports